import { onDelete } from "../../../function/onDelete";
import { deleteReceivingAndShipping } from "./query";
import updatePOOpenQtyFromArray from "../../../function/utilityAPI/updatePOOpenQtyFromArray";
import updateInvenotryFromArray from "../../../function/utilityAPI/updateInvenotryFromArray";

export default async function onDeleteShipping({
  selectionModel,
  setSelectionModel,
  client,
  values,
  type,
}) {
  // #region agent log
  console.warn('[DEBUG-7f7852] onDeleteShipping ENTRY', { hasSelectionModel: !!selectionModel, selectionModelLength: selectionModel?.length, hasValues: !!values, type, items: selectionModel?.map(x => ({ id: x?.id, qty: x?.qty, materialID: x?.materialID, poID: x?.poID, isUndefined: x === undefined })) });
  // #endregion
  if (type !== "RECEIVING" && type !== "SHIPPING")
    return alert("type must be RECEIVING or SHIPPING");
  if (selectionModel) {
    try {
      await Promise.all(
        selectionModel?.map(async (items) => {
          await deleteSingleItem(items, client);
        })
      );
    } catch (e) {
      // #region agent log
      console.warn('[DEBUG-7f7852] deleteSingleItem Promise.all FAILED', { error: e?.message, stack: e?.stack });
      // #endregion
    }
    setSelectionModel && setSelectionModel([]);
  } else if (values) {
    await deleteSingleItem(values, client);
  }

  // #region agent log
  console.warn('[DEBUG-7f7852] after delete, about to update PO', { arrLength: (selectionModel || [values]).length });
  // #endregion

  try {
    await updatePOOpenQtyFromArray({
      client,
      arr: selectionModel || [values],
      type: "add",
    });
  } catch (e) {
    // #region agent log
    console.warn('[DEBUG-7f7852] updatePOOpenQtyFromArray FAILED', { error: e?.message });
    // #endregion
  }

  // #region agent log
  console.warn('[DEBUG-7f7852] about to call updateInvenotryFromArray', { type, inventoryType: type === 'SHIPPING' ? 'add' : 'deduct' });
  // #endregion

  await updateInvenotryFromArray({
    client,
    arr: selectionModel || [values],
    type: type === "SHIPPING" ? "add" : "deduct",
  });

  // #region agent log
  console.warn('[DEBUG-7f7852] onDeleteShipping COMPLETED SUCCESSFULLY');
  // #endregion
}

async function deleteSingleItem(item, client) {
  // console.log({ item, client });
  const { id, number } = item || {};

  await onDelete({
    input: { id },
    mutation: deleteReceivingAndShipping,
    // updateCacheFields: ["relationsByCustomerID"],
    client,
    storagePath: number,
  });
}
